import { render } from "./SearchWithDropdown.vue?vue&type=template&id=5b6b76d6&scoped=true"
import script from "./SearchWithDropdown.vue?vue&type=script&lang=js"
export * from "./SearchWithDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6b76d6"]])

export default __exports__